export default {"src":"/_next/static/media/half_white_diji.ee44e137.svg","height":177,"width":1700};